// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSearchSecond_root__A1iZy"};